import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core'

import { Favorite } from '../../shared/interfaces/resources/favorite.interface'
import { FavoriteService } from '../../shared/services/favorite.service'
import { listAnimation } from './list.animation'

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  animations: [listAnimation]
})
export class CartComponent {
  @Input() favoriteIncentives: Favorite[] = []
  @Input() lastAddedIncentives: Favorite[] = []
  @Input() isCartOpen: boolean

  @Output() onCloseModal: EventEmitter<void> = new EventEmitter()

  constructor(
    private elementRef: ElementRef,
    private favoriteService: FavoriteService
  ) {}

  remove(id: string) {
    this.favoriteService.remove(id)
  }

  removeOldFavorites() {
    const oldFavorites: Favorite[] = this.favoriteIncentives.filter(
      (incentive) => !this.lastAddedIncentives.includes(incentive)
    )

    this.favoriteService.remove(oldFavorites.map((incentive) => incentive.id))
  }

  resetFavorites() {
    this.favoriteService.removeAllFavorites()
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: any) {
    if (
      !this.elementRef.nativeElement.contains(event.target) &&
      event.target.id !== 'my-comparator' &&
      event.target.type !== 'checkbox' &&
      // For some reason, the first expression is not working on deep nested elements.
      !event.target.className.includes('is-inside-cart')
    ) {
      this.onCloseModal.emit()
    }
  }
}
